export default container => {
  const videos = container.querySelectorAll('[data-video]')

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        entry.target.pause()
      }

      if (entry.isIntersecting) {
        entry.target.play()
      }
    })
  })

  videos.forEach(video => observer.observe(video))
}
